import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { ObstetricalFileControlRenderer } from "@/Patient/Components/MedicalNote/ObstetricalFile/ControlRenderer/ObstetricalFileControlRenderer";
import { QuebecObstetricalFileFieldLimits } from "@/Patient/Components/MedicalNote/ObstetricalFile/Form/Quebec/QuebecObstetricalFileFieldLimits";
import { Signature } from "@/Patient/Models/ObstetricalFile/Quebec/Signature";

interface IQuebecObstetricalFilePageFooterProps {
    signature: Signature;
    isInformationShared: boolean;
    informationLabel: string;
    readonly?: boolean;

    onSignatureChange: (signature: string) => void;
    onDateChange: (date: Date) => void;
    onInformationSharedChange: (isShared: boolean) => void;

    onFieldBlur: () => void;
}

class QuebecObstetricalFilePageFooter extends BaseReactComponent<IQuebecObstetricalFilePageFooterProps> {
    private componentId: string = "obstetrical-file-footer";

    public render(): JSX.Element {
        if (!this.props)
            return null;

        let controlRenderer = new ObstetricalFileControlRenderer({
            readonly: this.props.readonly,
            onBlur: () => this.props.onFieldBlur?.()
        });

        return (
            <div id={this.componentId}>
                <div className="section border border-top footer">
                    <div className="row">
                        <div className="col-lg-8">
                            <span className="field-label-inline">{cacheStore.GetString("SignatureLabel")}</span>
                            <div className="field-value-inline textbox">
                                {controlRenderer.renderTextbox({
                                    value: this.props.signature.Value,
                                    onChange: value => this.props.onSignatureChange?.(value),
                                    maxLength: QuebecObstetricalFileFieldLimits.Page1.PageOneSignature.MaxChars
                                })}
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <span className="field-label-inline">{cacheStore.GetString("DateLabel")}</span>
                            <div className="field-value-inline">
                                {controlRenderer.renderDateSelector({
                                    value: this.props.signature.Date,
                                    onChange: value => this.props.onDateChange?.(value),
                                    id: "signature_date"
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 information-shared">
                            <strong className="label">{cacheStore.GetString(this.props.informationLabel)}</strong>
                            <div className="field">
                                <CheckboxControl
                                    checked={this.props.isInformationShared}
                                    disabled={this.props.readonly}
                                    label={cacheStore.GetString("InformationSharedLabel")}
                                    onChange={checked => {
                                        this.props.onInformationSharedChange?.(checked);
                                        this.props.onFieldBlur?.();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { QuebecObstetricalFilePageFooter };
